import React, { useState, useEffect } from 'react'
import get from 'lodash/get'

import fetchCrawlerData from '../../services/fetch-crawler-data'
import removeCrawlerData from '../../services/remove-crawler-data'
import finishSignup from '../../services/finish-signup'

import whatsapp from '../../assets/whatsapp.png'
import contraktor from '../../assets/partners/contraktor.png'
import liberty from '../../assets/partners/liberty-seguros.png'
import portoSeguro from '../../assets/partners/porto-seguro.png'

import Header from '../../components/Header'

import './crawler.scss'
import useFacebook from '../../custom-hooks/useFacebook'

import Context from '../../store/context'
import Home from './components/Home'
import EditAnnouncement from './components/EditAnnouncement'
import Success from './components/Success'
import { filterString } from 'helpers/cleanup'

function Crawler() {
  const urlParams = new URLSearchParams(window.location.search)
  /* Legacy conversion params. Can be removed in the near future when no more links depend on it */
  const sourceId = urlParams.get('id')
  const source = urlParams.get('source') || 'olx'
  /* */
  const announcementId = urlParams.get('ref')
  const token = urlParams.get('token')
  const [isLoading, setIsLoading] = useState(false)

  const [propertyAnnouncement, setPropertyAnnouncement] = useState(undefined)
  const [done, setDone] = useState()
  const [error, setError] = useState()
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    password: '',
  })

  /* eslint-disable */
  const [step, setStep] = useState(0)

  const goToSuccessPage = () => {
    setStep(2)
  }

  const getCurrentStep = () => {
    switch (step) {
      case 0:
      default:
        const hasFinished = done && done.reason === 'finished'
        return (
          <Home
            propertyAnnouncement={propertyAnnouncement}
            fbSdkLoaded={fbSdkLoaded}
            form={form}
            isLoading={isLoading}
            error={error}
            onClickFacebook={onClickFacebook}
            hasSubmited={hasFinished}
            showStoreButtons={hasFinished}
            updateField={updateField}
            updateUser={updateUser}
          />
        )
      case 1:
        return (
          <EditAnnouncement
            propertyAnnouncement={propertyAnnouncement}
            goToSuccessPage={() => goToSuccessPage()}
          />
        )
      case 2:
        return <Success />
    }
  }

  const { fbSdkLoaded } = useFacebook()

  useEffect(() => {
    async function fetchData() {
      if (propertyAnnouncement === undefined) {
        try {
          const data = await fetchCrawlerData(announcementId, { source, sourceId, token })

          setPropertyAnnouncement(data.propertyAnnouncement)
          setForm({
            ...form,
            name: get(data, 'propertyAnnouncement.user.name') || form.name,
            phone: get(data, 'propertyAnnouncement.user.phone') || form.phone,
          })
        } catch (error) {
          setPropertyAnnouncement(null)
        }
      }
    }
    fetchData()
  }, [form, propertyAnnouncement, announcementId, sourceId, source, token]) // eslint-ignore

  const conversionFrom =
    get(propertyAnnouncement, 'positive_ratings') > 0 ? 'crawler-signup' : 'no-interested-crawler-signup'

  const updateUser = async (e) => {
    setIsLoading(true)
    try {
      const formattedForm = {
        ...form,
        phone: filterString(form.phone, ['(', ')', ' ', '-']),
      }
      await finishSignup(announcementId, { source, sourceId, token }, { data: formattedForm, conversionFrom })
      setDone({ reason: 'finished' })
      setError(null)
      setStep(1)
    } catch (error) {
      console.log('error', { error })
      const errorCode = get(error, 'data.data.code') || get(error, 'code')

      if (errorCode === 'duplicated_email') {
        setError('Email já cadastrado. Por favor insira um novo email ou contate nosso suporte.')
      } else {
        setError('Não foi possível realizar o seu cadastro. Por favor tente novamente mais tarde.')
      }
    } finally {
      setIsLoading(false)
    }
  }

  const updateField = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }))
  }

  const removeData = async () => {
    await removeCrawlerData(announcementId, { source, sourceId, token })
    setDone({ reason: 'removed' })
  }

  const processFacebookData = async (facebookToken) => {
    setIsLoading(true)
    try {
      await finishSignup(
        announcementId,
        { source, sourceId, token },
        { data: form, facebookToken, conversionFrom },
      )
      setDone({ reason: 'finished' })
      setStep(1)
    } catch (error) {
      console.log(error.data)
    } finally {
      setIsLoading(false)
    }
  }

  const onClickFacebook = (e) => {
    e.preventDefault()
    // @ts-ignore
    window.FB.login(
      (response) => {
        if (response.status === 'connected') {
          // Logged into your webpage and Facebook.
          processFacebookData(response.authResponse.accessToken)
        } else {
          // The person is not logged into your webpage or we are unable to tell.
          console.log("couldn't log in with facebook")
        }
      },
      { scope: 'public_profile,email' },
    )
  }

  const context = { announcement: propertyAnnouncement }

  if (propertyAnnouncement) {
    return (
      <div>
        <Context.Provider value={context}>
          <Header
            textComponent={
              <>
                <h1 className='header__headline'>O seu imóvel nas melhores mãos:</h1>
                <span className='header__headline-big'>AS SUAS!</span>
              </>
            }
          />
          {getCurrentStep()}
          <footer>
            <div className='learn-more'>
              <h1 className='learn-more__headline'>Saiba mais</h1>
              <p className='learn-more__subheadline'>
                Vem conversar com a gente que explicamos tudo para você via WhatsApp. Temos certezas que
                iremos encantar você!
              </p>

              <a className='learn-more__button' href='https://api.whatsapp.com/send?phone=+5541996558095'>
                Fale com a gente
                <img className='learn-more__button-image' src={whatsapp} alt='Whatsapp logo' />
              </a>
            </div>
            <div className='partners'>
              <h1 className='partners__headline'>Nossos Parceiros</h1>
              <div className='partners__wrapper'>
                <img className='partners__logo' src={portoSeguro} alt='Porto Seguro Logo' />
                <img className='partners__logo' src={liberty} alt='Liberty Seguros Logo' />
                <img className='partners__logo contraktor' src={contraktor} alt='Contraktor Logo' />
              </div>
            </div>
          </footer>
          <div className='remove'>
            {!done ||
              (done && done.reason !== 'removed' && (
                <>
                  <h1 className='remove__headline'>Quero remover meu anúncio!</h1>
                  <p className='remove__subheadline'>
                    Entendemos e respeitamos a sua decisão, mas convidamos você a dar uma olhadinha em tudo
                    que a Mellro pode oferecer para você :)
                  </p>
                  <button onClick={removeData} className='remove__button'>
                    Remover meu anúncio
                  </button>
                </>
              ))}
            {done && done.reason === 'removed' && (
              <div>
                <h1>Mellro</h1>
                <p>Seus dados foram removidos da nossa plataforma</p>
              </div>
            )}
          </div>
        </Context.Provider>
      </div>
    )
  }

  if (propertyAnnouncement === null) {
    return (
      <div className='error'>
        <h1>Mellro</h1>
        <p>Desculpe, este link não está mais acessível.</p>
      </div>
    )
  }

  return null
}

export default Crawler
